<div class="page-header">
  <div class="header-content">
    <!-- <div class="breadcrumb">
        <a>Orders</a>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
        <span>Order Details</span>
      </div> -->
    <a class="go-back-btn" (click)="goBack()">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Go Back
    </a>
  </div>
</div>
<div class="order-listing-container" (click)="closeAllDropdowns()">

  <!-- Filter Chips Section -->
  <!-- <div class="filter-chips-container">
    <div class="filter-chips">
      <button class="filter-chip" [class.active]="isChipActive('all')" (click)="setFilter('all')">
        All <span class="chip-badge">{{ getFilterCount('all') }}</span>
      </button>
      <button class="filter-chip" [class.active]="isChipActive('pending')" (click)="setFilter('pending')">
        Pending <span class="chip-badge">{{ getFilterCount('pending') }}</span>
      </button>
      <button class="filter-chip" [class.active]="isChipActive('successful')" (click)="setFilter('successful')">
        Successful <span class="chip-badge">{{ getFilterCount('successful') }}</span>
      </button>
      <button class="filter-chip" [class.active]="isChipActive('unsuccessful')" (click)="setFilter('unsuccessful')">
        Unsuccessful <span class="chip-badge">{{ getFilterCount('unsuccessful') }}</span>
      </button>
      <button class="filter-chip" [class.active]="isChipActive('cancelled')" (click)="setFilter('cancelled')">
        Cancelled <span class="chip-badge">{{ getFilterCount('cancelled') }}</span>
      </button>
    </div>

    <div class="filter-actions">
      <input type="date" class="date-input" [(ngModel)]="orderDate" (change)="setDatefilter()" />
      <button class="btn btn-secondary" (click)="toggleAdvancedFilters()">
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" />
        </svg>
        Advanced Filters
      </button>
      <button class="btn btn-secondary" (click)="clearFilters()">
        Clear Filters
      </button>
    </div>
  </div> -->

  <!-- Page Title & Actions -->
  <!-- <div class="page-header">
    <h2 class="table-title">Today's Deliveries</h2>
    <div class="table-actions">
      <button class="btn btn-secondary" (click)="exportOrders()">
        <svg width="18" height="18" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"/>
        </svg>
        Export
      </button>
    </div>
  </div> -->


  <!-- Order Table -->
  <div class="table-wrapper" #tableContainer (scroll)="onTableScroll($event)" cdkScrollable>
    <table>
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Contact Name</th>
          <th>Address</th>
          <th>Delivery Date</th>
          <th>Committed<br>Time</th>
          <th>Delivery Time<br>(Delay)</th>
          <th>
            <div class="filter-header">
              Driver
              <!-- <button class="column-filter-btn"
                (click)="showDriverFilter = !showDriverFilter; $event.stopPropagation()">
                <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" />
                </svg>
              </button> -->
            </div>

            <!-- Driver Filter Dropdown -->
            <div class="column-filter-dropdown" *ngIf="showDriverFilter" (click)="$event.stopPropagation()">

              <div class="filter-dropdown-header">
                <span>Filter by Driver</span>
                <span class="filter-dropdown-clear" (click)="selectedDrivers = []; driverId = []; applyFilters()">
                  Clear
                </span>
              </div>
              <!-- Dynamic Drivers from API -->
              <label class="filter-option" *ngFor="let driver of driverList">
                <input type="checkbox" [value]="driver.id" [checked]="selectedDrivers.includes(driver.id)"
                  (change)="onDriverChange(driver.id, $event)">
                <span>
                  {{ driver.first_name }} {{ driver.last_name }}
                </span>
              </label>

            </div>
          </th>

          <th>
            <div class="filter-header">
              Status
              <!-- <button class="column-filter-btn"
                (click)="showStatusFilter = !showStatusFilter; $event.stopPropagation()">
                <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" />
                </svg>
              </button> -->
            </div>
            <!-- Status Filter Dropdown -->
            <div class="column-filter-dropdown" *ngIf="showStatusFilter" (click)="$event.stopPropagation()">
              <div class="filter-dropdown-header">
                <span>Filter by Status</span>
                <span class="filter-dropdown-clear" (click)="selectedStatuses = []; applyFilters()">Clear</span>
              </div>
              <!-- <label class="filter-option">
                <input type="checkbox" value="all" [(ngModel)]="selectedStatuses" (change)="applyFilters()">
                <span>All Status</span>
              </label> -->
              <label class="filter-option">
                <input type="checkbox" value="pending" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('pending')">
                <span>Pending</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="successful" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('successful')">
                <span>Successful</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="unsuccessful" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('unsuccessful')">
                <span>Unsuccessful</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="cancelled" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('cancelled')">
                <span>Cancelled</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="shipped" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('shipped')">
                <span>Shipped</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="en-route" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('en-route')">
                <span>En-Route</span>
              </label>
              <label class="filter-option">
                <input type="checkbox" value="arrived" (change)="onStatusChange($event)"
                  [checked]="selectedStatuses.includes('arrived')">
                <span>Arrived</span>
              </label>
            </div>
          </th>
          <!-- <th style="text-align: center;">Actions</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders" [attr.data-order-id]="order.id"
          [style.background-color]="order?.background_colour"
          [style.border-bottom]="order?.pending_order_group_visuals?.underline ? '2px solid ' + order?.pending_order_group_visuals?.color : 'none'"
          [ngClass]="{'unverified': !order.is_verified}" (dblclick)="toggleRowSelection(order)"
          [class.selected-row]="order.selected">
          <td>
            <div class="order-id">
              <div class="order-icon" [class.pickup]="order.order_type === 'pickup'"
                [class.delivery]="order.order_type === 'delivery'" [class.warehouse]="order.order_type === 'warehouse'">
                {{
                order.order_type === 'pickup' ? 'P' :
                order.order_type === 'warehouse' ? 'W' :
                'D'
                }}
              </div>

              {{
              order.parent_order == null
              ? (order.order_type == 'pickup' ?order.po :order.order_no)
              : (order.order_no )
              }}
              <div
                *ngIf="(order?.order_type === 'pickup' && order?.pickup_multiple_order_ids?.length > 0) ||
                      (order?.order_type === 'delivery' && order?.dely_multiple_order_ids?.length > 0) || (order?.order_type === 'pickup' && order?.dely_multiple_order_ids?.length > 0 && order.parent_order != null)"
                class="circle cursor-pointer" [matTooltip]="formattedOrderIds(order)">
                <div class="inner-circle">
                  <span>m</span>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="customer-info">
              <div class="customer-name">{{ order.customer_name }}</div>
              <div class="customer-company">{{ order.parent_order == null
                ? (order.order_type == 'pickup' ? order.pickup_company_name : order.dely_company_name)
                : (order.dely_company_name ) }}</div>
            </div>
          </td>
          <td class="address" [ngClass]="{'unverified': !order.is_verified, 'red-text': !order.is_verified}">{{
            order.customer_addr }}</td>
          <td style="text-align: center;" [innerHTML]="convertToLocalDate(order.dely_date, true)"></td>
          <td style="text-align: center;" [ngStyle]="order.is_late ? {'color': '#FF0000'} : {}">{{ order.order_type ==
            'pickup' ?
            convertTime24To12(order.pickup_time) :
            convertTime24To12(order.dely_time) }}
            <i *ngIf="order.is_late && Object.keys(order.current_driver || {}).length > 0" class="material-icons"
              style="color: #afbac5; font-size: 18px; cursor: pointer; position: relative; top: 5px;"
              matTooltip="The red-colored time indicates a potential delay in meeting the committed time">
              info
            </i>
          </td>
          <td style="text-align: center;" [ngStyle]="{'color': getColor(order)}">

            <!-- Jab successful / unsuccessful na ho -->
            <span *ngIf="order.order_status != 'successful' && order.order_status != 'unsuccessful'"
              style="color: black;">
              N/A
            </span>

            <!-- Jab successful / unsuccessful ho -->
            <span *ngIf="order.order_status == 'successful' || order.order_status == 'unsuccessful'">
              {{ getDateTime(order, order.order_status) | date:'shortTime' }}
            </span>

            <br>

            <!-- Delay time -->
            <span *ngIf="getFirstPart(order.delayed_order_time)" style="position: relative; top: 5px;">
              <span style="color: #FF0000;">
                ({{ getFirstPart(order.delayed_order_time) }}
                {{ getTimeUnit(getFirstPart(order.delayed_order_time)) }})
              </span>
            </span>

          </td>

          <td>
            <div class="driver-profile" *ngIf="order?.current_driver && order?.current_driver?.first_name">
              <!-- <div class="driver-avatar">{{ getDriverInitials(order?.current_driver) }}</div> -->
              <div
                [ngClass]="{'unverified': order.order_status === 'en-route' || order.order_status === 'warehouse' || order.order_status === 'arrived'}"
                class="driver-name">{{ getDriverDisplayName(order?.current_driver) }}</div>
            </div>
          </td>
          <td>
            <div class="eta-status-cell" (click)="goToOrderDetail(order.id)">
              <span [class]="getStatusClass(order.order_status)">
                {{ order.order_status | titlecase }}<span *ngIf="(order.order_type === 'delivery' && order.is_dely_first_delivery) 
      || (order.order_type === 'pickup' && order.is_pickup_first_delivery)" class="first-delivery">
                  {{ order.order_type === 'delivery'
                  ? order.is_dely_first_delivery
                  : order.is_pickup_first_delivery }}
                </span>
              </span>
              <span *ngIf="shouldShowETA(order)" class="eta">ETA: {{ formatETDA(order.eta[0].etda) }}</span>
              <span *ngIf="shouldShowArrived(order)" class="eta">AT: {{ formatETDAs(order) }}</span>

            </div>
          </td>
          <!-- <td>
            <div class="actions-cell">
              <div class="action-dropdown">
                <button class="action-btn action-dropdown-btn"
                  (click)="toggleDropdown(order.id); $event.stopPropagation()">
                  ⋮
                </button>
              </div>
              <input type="checkbox" class="row-checkbox order-checkbox" [(ngModel)]="order.selected"
                (change)="updateSelectionCount()" [disabled]="!order.is_verified"
                [matTooltip]="!order.is_verified ? 'The address provided with the order is invalid. Please edit and select a valid address.' : ''"
                matTooltipPosition="above">
            </div>
                <div class="dropdown-menu" *ngIf="activeDropdown === order.id" (click)="$event.stopPropagation()">
                  <div class="dropdown-item" (click)="goToOrderDetail(order.id); closeAllDropdowns()">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                      <path fill-rule="evenodd"
                        d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                        clip-rule="evenodd" />
                    </svg>
                    View Details
                  </div>
                  <div class="dropdown-item" (click)="editOrder(order); closeAllDropdowns()">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                    Edit Order
                  </div>
                  <div class="dropdown-item" (click)="trackOrder(order); closeAllDropdowns()">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clip-rule="evenodd" />
                    </svg>
                    Track Order
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item danger" (click)="deleteOrder(order.id); closeAllDropdowns()">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd" />
                    </svg>
                    Delete Order
                  </div>
                </div>
          </td> -->
        </tr>
      </tbody>
    </table>

    <!-- Loading Indicator -->
    <div class="loading-indicator" *ngIf="isLoading">
      <div class="loading-spinner"></div>
      <span>Loading more orders...</span>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="orders.length === 0 && !isLoading">
      <svg width="64" height="64" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
          clip-rule="evenodd" />
      </svg>
      <p>No orders found</p>
      <!-- <button class="btn btn-primary" (click)="clearFilters()">Clear Filters</button> -->
    </div>
  </div>

  <!-- Dashboard Style Footer - Fixed Bottom Left -->
  <div class="table-footer">
    <div class="pagination-info-group">
      <div class="pagination-info">
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path fill-rule="evenodd"
            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd" />
        </svg>
        <!-- <span id="paginationText"> {{ displayedOrders.length > 0 ? '1-' + displayedOrders.length : '0' }} of -->
        <span id="paginationText">
          <!-- Showing {{ totalOrders }}
          orders -->
          {{ getPaginationInfo()}}
        </span>
      </div>
      <div class="scroll-progress-bar">
        <div class="scroll-progress-fill" [style.width.%]="scrollProgress"></div>
      </div>
    </div>
  </div>

</div>

<!-- Bulk Actions Bar (Fixed Bottom) -->
<div class="bulk-actions-bar" [class.show]="showBulkActions" *ngIf="selectedCount > 0">
  <div class="bulk-selection-info">
    <span class="bulk-selection-count">
      <span>{{ selectedCount }}</span> orders selected
    </span>
    <button class="btn" style="background: rgba(255,255,255,0.1); color: white; border-color: rgba(255,255,255,0.2);"
      (click)="clearSelection()">
      Clear Selection
    </button>
  </div>
  <div class="bulk-actions">
    <!-- (click)="bulkAssign()" -->
    <button class="bulk-action-btn" (click)="openAssignOrder()">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path
          d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
      </svg>
      Assign
    </button>
    <button class="bulk-action-btn" (click)="bulkUnassign()">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path d="M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z" />
      </svg>
      Unassign
    </button>
    <!-- (click)="openReAssignOrder() -->
    <button class="bulk-action-btn" (click)="openReAssignOrder()"> >
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path
          d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
      </svg>
      Reassign
    </button>
    <button class="bulk-action-btn" (click)="bulkRoute()">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
          clip-rule="evenodd" />
      </svg>
      Route
    </button>
    <button class="bulk-action-btn" (click)="bulkRefresh()">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
          clip-rule="evenodd" />
      </svg>
      Refresh (ETA)
    </button>
    <button class="bulk-action-btn danger" (click)="bulkDelete()">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clip-rule="evenodd" />
      </svg>
      Delete
    </button>
  </div>
</div>

<app-assign-order-modal *ngIf="assignorder" [orderIds]="selectedOrders" [visible]="showAssignOrderModal"
  [isassign]="showAssign" (close)="showAssignOrderModal = false" (assign)="handleAssignOrder($event)">
</app-assign-order-modal>